(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let motionOff = reduced.matches;
  try { motionOff = motionOff || sessionStorage.getItem('cp-motion') === 'off'; } catch {}
  document.documentElement.classList.add('cp-ready');
  const journey = document.querySelector('[data-journey]');
  const motionButton = document.querySelector('[data-motion]');
  const applyMotion = () => {
    document.documentElement.classList.toggle('motion-off', motionOff);
    if (motionButton) {
      motionButton.setAttribute('aria-pressed', String(motionOff));
      motionButton.setAttribute('aria-label', motionOff ? motionButton.dataset.resume : motionButton.dataset.pause);
      motionButton.textContent = motionOff ? '▷' : 'Ⅱ';
    }
  };
  applyMotion();
  if (motionButton) motionButton.addEventListener('click', () => { motionOff = !motionOff; applyMotion(); try { sessionStorage.setItem('cp-motion', motionOff ? 'off' : 'on'); } catch {} updateJourney(); });
  reduced.addEventListener('change', e => { motionOff = e.matches; applyMotion(); updateJourney(); });
  let frame = false;
  const clamp = value => Math.max(0, Math.min(1, value));
  function updateJourney() {
    if (!journey) return;
    const rect = journey.getBoundingClientRect();
    const progress = motionOff ? 0 : clamp(-rect.top / Math.max(1, journey.offsetHeight - window.innerHeight));
    const fade = clamp((progress - .48) / .27);
    journey.style.setProperty('--progress', progress);
    journey.style.setProperty('--inside', fade);
    journey.style.setProperty('--intro', 1 - clamp(progress / .45));
    journey.style.setProperty('--end', clamp((progress - .68) / .22));
    journey.querySelector('.journey-intro').inert = progress > .4;
    journey.querySelector('.journey-ending').inert = progress < .75;
    journey.querySelectorAll('.journey-chapters span').forEach((item, i) => item.classList.toggle('active', i === (progress < .25 ? 0 : progress < .65 ? 1 : 2)));
    frame = false;
  }
  if (journey) { updateJourney(); window.addEventListener('scroll', () => { if (!frame) { frame = true; requestAnimationFrame(updateJourney); } }, {passive:true}); window.addEventListener('resize', updateJourney); }
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), {threshold:.08});
    document.querySelectorAll('.reveal').forEach(item => observer.observe(item));
  }
  const menu = document.querySelector('.mobile-menu');
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && menu?.open) { menu.open = false; menu.querySelector('summary').focus(); } });
  const thumbs = document.querySelectorAll('[data-gallery-thumb]');
  const slides = document.querySelectorAll('[data-gallery-slide]');
  const dialog = document.querySelector('[data-image-dialog]');
  thumbs.forEach(button => button.addEventListener('click', () => {
    thumbs.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    slides.forEach(item => { const current = item.dataset.gallerySlide === button.dataset.galleryThumb; item.hidden = !current; item.classList.toggle('is-current', current); });
  }));
  slides.forEach(slide => slide.addEventListener('click', () => { if (!dialog) return; const image = slide.querySelector('img'); const target = dialog.querySelector('img'); target.src = slide.dataset.fullSrc || image.currentSrc || image.src; target.alt = image.alt; dialog.showModal(); }));
  if (dialog) { dialog.querySelector('button').addEventListener('click', () => dialog.close()); dialog.addEventListener('click', e => { if (e.target === dialog) dialog.close(); }); }
  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) variantSelect.addEventListener('change', () => { const url = new URL(location.href); url.searchParams.set('variant', variantSelect.value); location.assign(url); });
  const collection = document.querySelector('[data-collection]');
  if (collection) {
    const grid = collection.querySelector('[data-product-grid]');
    const cards = Array.from(grid.querySelectorAll('.product-card'));
    collection.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => { collection.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button))); cards.forEach(card => card.hidden = button.dataset.filter !== 'all' && card.dataset.kind !== button.dataset.filter); }));
    collection.querySelector('[data-sort]').addEventListener('change', e => { const direction = e.target.value === 'asc' ? 1 : -1; const sorted = e.target.value === 'default' ? cards : [...cards].sort((a,b) => direction * (Number(a.dataset.price)-Number(b.dataset.price))); sorted.forEach(card => grid.appendChild(card)); });
  }
})();

/* Shopify is the source of truth; only replace the drawer after a confirmed response. */
(() => {
  const initial = document.querySelector('[data-cart-fragment]');
  if (!initial || !window.fetch || !window.HTMLDialogElement) return;
  const labels = {...initial.dataset};
  const cartUrl = labels.cartUrl;
  const sectionId = 'cp-cart-drawer';
  let pending = false;
  let returnFocus = null;
  const drawer = () => document.querySelector('[data-cart-drawer]');
  const feedback = document.querySelector('[data-cart-feedback]');
  const announce = text => { if (feedback) feedback.textContent = text; };
  function busy(value) {
    pending = value;
    drawer()?.setAttribute('aria-busy', String(value));
    document.querySelectorAll('[data-add],[data-cart-change],.cart-drawer [name="checkout"]').forEach(button => {
      if (value) { button.dataset.wasDisabled = String(button.disabled); button.disabled = true; }
      else { button.disabled = button.dataset.wasDisabled === 'true'; delete button.dataset.wasDisabled; }
    });
  }
  function open(opener) {
    const dialog = drawer();
    if (dialog && !dialog.open) {
      returnFocus = opener?.isConnected ? opener : document.activeElement;
      document.querySelector('.mobile-menu')?.removeAttribute('open');
      dialog.showModal();
      document.documentElement.classList.add('cart-is-open');
    }
  }
  function close() {
    drawer()?.close();
    document.documentElement.classList.remove('cart-is-open');
    if (returnFocus?.isConnected) returnFocus.focus();
  }
  function bindDialog() {
    const dialog = drawer();
    dialog?.addEventListener('close', () => {
      if (drawer() !== dialog || dialog.open) return;
      document.documentElement.classList.remove('cart-is-open');
      if (returnFocus?.isConnected) returnFocus.focus();
    });
    dialog?.addEventListener('click', event => { if (event.target === dialog) close(); });
  }
  bindDialog();
  function replace(sections, focus) {
    const html = sections?.[sectionId];
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = parsed.querySelector('[data-cart-fragment]');
    const current = document.querySelector('[data-cart-fragment]');
    if (!incoming || !current) return false;
    const wasOpen = drawer()?.open;
    const originalOpener = returnFocus;
    if (wasOpen) drawer().close();
    current.replaceWith(incoming);
    bindDialog();
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = incoming.dataset.count);
    const page = document.querySelector('[data-cart-page]');
    if (page && sections[page.dataset.sectionId]) {
      const updated = new DOMParser().parseFromString(sections[page.dataset.sectionId], 'text/html').querySelector('[data-cart-page]');
      if (updated) page.replaceWith(updated);
    }
    if (wasOpen) open(originalOpener);
    if (focus && wasOpen) {
      const line = Array.from(document.querySelectorAll('[data-cart-line]')).find(el => el.dataset.cartLine === focus.key);
      const next = line?.querySelector(`[data-cart-control="${focus.control}"]`) || line?.querySelector('[data-cart-change]') || drawer()?.querySelector('[data-cart-close]');
      next?.focus();
    }
    return true;
  }
  function sectionIds() {
    return [sectionId, document.querySelector('[data-cart-page]')?.dataset.sectionId].filter(Boolean);
  }
  async function refresh() {
    const url = new URL(cartUrl, location.origin);
    url.searchParams.set('sections', sectionIds().join(','));
    const response = await fetch(url, {credentials:'same-origin', headers:{Accept:'application/json'}, cache:'no-store'});
    if (!response.ok) throw Error(labels.error);
    if (!replace(await response.json())) throw Error(labels.error);
  }
  function showError(message, product = false) {
    const target = document.querySelector(product ? '[data-product-error]' : '[data-drawer-error]');
    if (target) { target.textContent = message; target.hidden = false; }
    announce(message);
  }
  async function mutate(url, body, product = false, focus) {
    if (pending) return;
    busy(true);
    document.querySelectorAll('[data-product-error],[data-drawer-error]').forEach(el => el.hidden = true);
    announce(labels.loading);
    try {
      const response = await fetch(url + '.js', {method:'POST', credentials:'same-origin', headers:{Accept:'application/json'}, body});
      const data = await response.json();
      if (!response.ok) throw Error(typeof data.description === 'string' ? data.description : labels.error);
      if (!replace(data.sections, focus)) await refresh();
      if (product) open(document.querySelector('[data-add]')); 
      announce(product ? labels.added : labels.updated);
    } catch (error) {
      // An unknown network result is never retried automatically: that could add twice.
      showError(error instanceof TypeError || error instanceof SyntaxError ? labels.error : error.message || labels.error, product);
    } finally { busy(false); }
  }
  document.addEventListener('submit', event => {
    const form = event.target.closest('#cp-product-form');
    if (!form) return;
    event.preventDefault();
    if (pending || !form.checkValidity()) return;
    const body = new FormData(form);
    body.set('sections', sectionIds().join(','));
    body.set('sections_url', location.pathname);
    mutate(labels.addUrl, body, true);
  });
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-cart-open]');
    if (opener && !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0) {
      event.preventDefault(); open();
      if (!pending) { busy(true); refresh().catch(error => showError(error.message)).finally(() => busy(false)); }
    }
    if (event.target.closest('[data-cart-close]')) close();
    const button = event.target.closest('[data-cart-change]');
    if (!button || pending) return;
    const quantity = Number(button.dataset.cartChange);
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const body = new FormData();
    body.set('id', button.dataset.key);
    body.set('quantity', quantity);
    body.set('sections', sectionIds().join(','));
    body.set('sections_url', location.pathname);
    mutate(labels.changeUrl, body, false, {key:button.dataset.key,quantity,control:button.dataset.cartControl});
  });
  // A cached page restored with Back/Forward must not display a stale cart count.
  window.addEventListener('pageshow', event => { if (event.persisted && !pending) refresh().catch(() => {}); });
})();

(() => {
  const menu = document.querySelector('.mobile-menu');
  if (!menu) return;
  const toggle = menu.querySelector('summary');
  const sync = () => toggle.setAttribute('aria-expanded', String(menu.open));
  sync(); menu.addEventListener('toggle', sync);
  document.addEventListener('click', event => { if (menu.open && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false; });
  window.matchMedia('(min-width: 1100px)').addEventListener('change', event => { if (event.matches) menu.open = false; });
})();
